/**
 * Factory that returns stable setter callbacks for the products form store slice.
 * Reduces boilerplate in useProductsForm.
 * @param {(arg: ((prev: object) => object) | object) => void} setProductsForm
 * @returns {Object} Setters for each productsForm key
 */
export function createProductsFormSetters(setProductsForm) {
  return {
    setMode: (v) => setProductsForm((prev) => ({ ...prev, mode: v })),
    setFormData: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        formData: typeof v === 'function' ? v(prev.formData) : v
      })),
    setFormError: (v) => setProductsForm((prev) => ({ ...prev, formError: v })),
    setFormSuccess: (v) => setProductsForm((prev) => ({ ...prev, formSuccess: v })),
    setSubmitting: (v) => setProductsForm((prev) => ({ ...prev, submitting: v })),
    setDeleting: (v) => setProductsForm((prev) => ({ ...prev, deleting: v })),
    setSelectedProduct: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        selectedProduct: v,
        ...(v == null ? { productSuppliersSyncedForProductId: null } : {})
      })),
    setProductSearchQuery: (v) => setProductsForm((prev) => ({ ...prev, productSearchQuery: v })),
    setShowProductDropdown: (v) => setProductsForm((prev) => ({ ...prev, showProductDropdown: v })),
    setProductNameFieldTouched: (v) =>
      setProductsForm((prev) => ({ ...prev, productNameFieldTouched: v })),
    setCategoryFieldTouched: (v) =>
      setProductsForm((prev) => ({ ...prev, categoryFieldTouched: v })),
    setCategorySearchQuery: (v) => setProductsForm((prev) => ({ ...prev, categorySearchQuery: v })),
    setSubCategorySearchQuery: (v) =>
      setProductsForm((prev) => ({ ...prev, subCategorySearchQuery: v })),
    setShowCategoryDropdown: (v) =>
      setProductsForm((prev) => ({ ...prev, showCategoryDropdown: v })),
    setShowSubCategoryDropdown: (v) =>
      setProductsForm((prev) => ({ ...prev, showSubCategoryDropdown: v })),
    setAdditionalDetails: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        additionalDetails: typeof v === 'function' ? v(prev.additionalDetails) : v
      })),
    setPendingAdditionalDetailDeletes: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        pendingAdditionalDetailDeletes:
          typeof v === 'function' ? v(prev.pendingAdditionalDetailDeletes) : v
      })),
    setProductSuppliers: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        productSuppliers: typeof v === 'function' ? v(prev.productSuppliers) : v
      })),
    setPendingProductSupplierDeletes: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        pendingProductSupplierDeletes:
          typeof v === 'function' ? v(prev.pendingProductSupplierDeletes) : v
      })),
    setPendingPictureAdds: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        pendingPictureAdds: typeof v === 'function' ? v(prev.pendingPictureAdds) : v
      })),
    setPendingPictureDeletes: (v) =>
      setProductsForm((prev) => ({
        ...prev,
        pendingPictureDeletes: typeof v === 'function' ? v(prev.pendingPictureDeletes) : v
      })),
    setPictureFileError: (v) => setProductsForm((prev) => ({ ...prev, pictureFileError: v })),
    setOpenDetailNameDropdownIndex: (v) =>
      setProductsForm((prev) => ({ ...prev, openDetailNameDropdownIndex: v })),
    setOpenSupplierDropdownIndex: (v) =>
      setProductsForm((prev) => ({ ...prev, openSupplierDropdownIndex: v })),
    setAttributesFromCategoryLoading: (v) =>
      setProductsForm((prev) => ({ ...prev, attributesFromCategoryLoading: v }))
  };
}
